/**
 * Centralized notification system using Ant Design message API
 */
import { message } from 'antd';

// Configure global settings
message.config({
  top: 60,
  duration: 3,
  maxCount: 3,
});

/**
 * Show success message
 * @param {string} content - Message content
 * @param {number} duration - Duration in seconds (default: 3)
 */
export const showSuccess = (content, duration = 3) => {
  message.success(content, duration);
};

/**
 * Show error message
 * @param {string|Error} error - Error message or Error object
 * @param {number} duration - Duration in seconds (default: 4)
 */
export const showError = (error, duration = 4) => {
  let errorMsg = 'An error occurred';

  if (typeof error === 'string') {
    errorMsg = error;
  } else if (error?.response?.data?.error) {
    errorMsg = error.response.data.error;
  } else if (error?.response?.data?.message) {
    errorMsg = error.response.data.message;
  } else if (error?.message) {
    errorMsg = error.message;
  }

  message.error(errorMsg, duration);
};

/**
 * Show warning message
 * @param {string} content - Message content
 * @param {number} duration - Duration in seconds (default: 3)
 */
export const showWarning = (content, duration = 3) => {
  message.warning(content, duration);
};

/**
 * Show info message
 * @param {string} content - Message content
 * @param {number} duration - Duration in seconds (default: 3)
 */
export const showInfo = (content, duration = 3) => {
  message.info(content, duration);
};

/**
 * Show loading message
 * @param {string} content - Message content
 * @param {number} duration - Duration in seconds (0 = manual dismiss)
 * @returns {function} Function to dismiss the loading message
 */
export const showLoading = (content = 'Loading...', duration = 0) => {
  return message.loading(content, duration);
};

/**
 * Destroy all messages
 */
export const destroyAll = () => {
  message.destroy();
};
